import { Component } from '@angular/core';
import {Checkbox, IonicPage, NavController, NavParams} from 'ionic-angular';
import {InitPreferenceStep2Page} from "../init-preference-step2/init-preference-step2";
import {InitWizardProvider} from "../../providers/init-wizard/init-wizard";
import {InitStepCounterPage} from "../init-step-counter/init-step-counter";
import {InitSummaryPage} from "../init-summary/init-summary";

/**
 * Generated class for the InitPreferenceStep1Page page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-init-preference-step1',
  templateUrl: 'init-preference-step1.html',
})
export class InitPreferenceStep1Page {
  nextHref: any = InitPreferenceStep2Page;
  errorVisible: boolean = false;
  constructor(public navCtrl: NavController, public navParams: NavParams, public initWizard: InitWizardProvider) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad InitPreferenceStep1Page');
  }

  selectValue(val: number, $event: Checkbox) {
    if(this.initWizard.question1 == val) {
      this.initWizard.question1 = null;
      return false;
    }
    this.initWizard.question1 = val;
    this.errorVisible = false;
  }

  goNext() {
    console.log(this.initWizard.question1);
    if(!this.initWizard.question1) {
      this.errorVisible = true;
    } else {
      this.navCtrl.push(this.nextHref)
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/init-preference-step1/init-preference-step1.ts